import isBoolean from 'lodash/isBoolean';
import { LaunchDarklyState } from '.';

export const castFlag = (flag: unknown | undefined): boolean => {
    if (!isBoolean(flag)) {
        return false;
    }

    return flag;
};

export const castLDFlags = (flags: Record<string, boolean | undefined>): LaunchDarklyState => {
    return {
        isInitialized: true,
        usePosMenuFastImport: castFlag(flags?.usePosMenuFastImport),
        useAssociatedPricingRules: castFlag(flags?.useAssociatedPricingRules),
        useModuleMarketplaceInUbereatsConfig: castFlag(flags?.useModuleMarketplaceInUbereatsConfig),
        useNewEditMenuPages: castFlag(flags?.useNewEditMenuPages),
        useNewPaymentMethodsPage: castFlag(flags?.useNewPaymentMethodsPage),
        useIoAnalyticsMobileDashboard: castFlag(flags?.useIoAnalyticsMobileDashboard),
        useGuestHierarchy: castFlag(flags?.useGuestHierarchy),
        useCustomerFormAutoGenerateEmailAndPassword: castFlag(flags?.useCustomerFormAutoGenerateEmailAndPassword),
        useEwalletExport: castFlag(flags?.useEwalletExport),
        useReportsV2: castFlag(flags?.useReportsV2),
        useMigratedPaygreenV3: castFlag(flags?.useMigratedPaygreenV3),
        useIopayKycInterface: castFlag(flags?.useIopayKycInterface),
        useCrossSelling: castFlag(flags?.useCrossSelling),
        useCollectiveCateringSalesSummary: castFlag(flags?.useCollectiveCateringSalesSummary),
        useOptionIncludeDepositsInTurnover: castFlag(flags?.useOptionIncludeDepositsInTurnover),
        useAiMenuScan: castFlag(flags?.useAiMenuScan),
        useShift: castFlag(flags?.useShift),
        useNewChannelsPage: castFlag(flags?.useNewChannelsPage),
        useNewBrandUserPermissionPage: castFlag(flags?.useNewBrandUserPermissionPage),
        useNewUsersPage: castFlag(flags?.useNewUsersPage),
        useNewBrandUserPermissionForPasswordChange: castFlag(flags?.useNewBrandUserPermissionForPasswordChange),
        useNewBrandsPage: castFlag(flags?.useNewBrandsPage),
        useNewAnalyticsCommercialRealtimeBoard: castFlag(flags?.useNewAnalyticsCommercialRealtimeBoard),
        useSalesSummaryExportWithTaxExcluded: castFlag(flags?.useSalesSummaryExportWithTaxExcluded),
        useGuestHierarchyTrainingNotification: castFlag(flags?.useGuestHierarchyTrainingNotification),
        useProductPropagation: castFlag(flags?.useProductPropagation),
        useShowPropagateButton: castFlag(flags?.useShowPropagateButton),
        usePricePerKg: castFlag(flags?.usePricePerKg),
        useStepPropagation: castFlag(flags?.useStepPropagation),
        usePickupPoints: castFlag(flags?.usePickupPoints),
        useNewRestaurantInfoPage: castFlag(flags?.useNewRestaurantInfoPage),
        useNewBrandRestaurantsPage: castFlag(flags?.useNewBrandRestaurantsPage),
        useOperationZones: castFlag(flags?.useOperationZones),
        banniereKiosk: castFlag(flags?.banniereKiosk),
    };
};
